import React from 'react'
import Contact_1 from '../1'
import { Development, Property, RealEstateDataPageComponentData } from 'types'

interface ExternalProps {
  data: Development | Property
  from: string
  development?: Development
  property?: Property
}

const Contact_4 = (props: RealEstateDataPageComponentData & ExternalProps) => {
  return <Contact_1 {...props} />
}

export default Contact_4
